import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { dividers } from 'theme';

export const HorizontalDivider: FC<BoxProps> = props => (
  <Box {...dividers.horizontal} {...props} />
);
